
import React from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Assignment } from "./types";

interface AssignmentsTabProps {
  assignments: Assignment[];
  onAddAssignment: () => void;
}

export const AssignmentsTab: React.FC<AssignmentsTabProps> = ({ 
  assignments, 
  onAddAssignment 
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-bold text-[#333333]">Assignations actuelles</h3>
        <Button 
          size="sm" 
          variant="outline"
          className="text-[#BD1E28] border-[#BD1E28]"
          onClick={onAddAssignment}
        >
          <Plus className="h-4 w-4 mr-1" />
          Ajouter
        </Button>
      </div>
      
      <div className="space-y-4">
        {assignments.map((assignment) => (
          <div key={assignment.id} className="border-b pb-3">
            <h4 className="font-bold text-[#333333]">{assignment.name}</h4>
            <p className="text-sm text-[#666666]">Du {assignment.startDate} au {assignment.endDate}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
